import React, { Component } from 'react';
import {useIntl, injectIntl, FormattedMessage} from 'react-intl';

class GreenDot extends Component {
	  render() {
		     const { formatMessage } = this.props.intl;
		     return(<span className="green-dot-desc">{formatMessage({ id: "dot.green"})}</span>)
		    }
}
export default injectIntl(GreenDot);
